import qs from 'qs'
import axios from 'axios'

import {
	mapActions,
	mapMutations
} from 'vuex'

import {
	Modal,
	Input,
	DIV,
	Switch
} from 'iview'

import {
	eventBus
} from '@/components/login/eventBus';

export default {
	data() {
		return {
			isShow: false,


		}
	},
	mounted() {

	},
	methods: {
		...mapActions([
			'getIsLogining',
			'updateComponentKey'

		]),
		isLogining() { // false 已登录   true 未登录
			if (localStorage.userToken) {
				this.$post(this.domain.dataRealization + 'dataCustomer/isLogin', {})
					.then((res) => {
						var isLogining = !res.data.content
						this.getIsLogining({
							isLogining
						})


					});
			} else {
				var isLogining = true
				this.getIsLogining({
					isLogining
				})
			}

		},
		fillProduct_(url) { //不需要登录
			window.open(url)
		},
		fillProduct(url, notReplace) { //是否替换路径上的地址：true：不替换  false：替换
			console.log(url)
			if (this.$store.state.user.isLogining) { // 未登录：true     已登录：false
				const fromPath = url;
				const additionalData = {};
				eventBus.$emit('show-login-dialog', fromPath, additionalData, notReplace);

			} else {
				this.updateAllComponents()
				if (notReplace) {
					this.$router.push({
						path: url
					});
				} else {
					window.location.href=url
					// window.open(url)
				}

			}
		},
		serverDetails(url,i){
			this.$router.push({
				name: url,
				query: {
					type: i
				}
			})
		},
		getInfo(setupType) {
			this.$Spin.show();
			this.$post(this.domain.dataRealization + 'pageSetup/getPageSetup', qs.stringify({
					channelCode: window.channel,
					setupType: setupType
				}))
				.then((res) => {
					var this_ = this
					this.pageSetup = JSON.parse(res.data.content.setupContent)

					// setTimeout(function(){
					this_.isShow = true
					this_.$Spin.hide();
					// },3000)


				});
		},
		openPdf(url) { //打开pdf
			window.open(url)
		},
		hexToRgb(hex, a) {
			// 去除 # 符号
			var color = hex.replace("#", "");

			// 分割 RGB 三原色部分
			var r = parseInt(color.substring(0, 2), 16);
			var g = parseInt(color.substring(2, 4), 16);
			var b = parseInt(color.substring(4, 6), 16);

			return `rgba(${r}, ${g}, ${b},${a})`;
		},
		handleMaxSize(file) {
			this.$Message.warning('上传的图片不能超过2M')
		},
		getCaptcha(phoneNum, uuid, pictureCode) { //发送短信验证码
			const phone = phoneNum.trim()
			if (phone) {
				// 获取验证码
				this.$post(this.domain.dataRealization + 'dataCustomer/sendPhoneCode', qs.stringify({
						phoneNum: phoneNum,
						uuid: uuid,
						verifiCode: pictureCode
					}))
					.then((res) => {
						res = res.data
						this.noteStatus = res.code
						this.noteMsg = res.message
						if (res.code == 200) {
							this.cooling = 60
							let coolingInter = setInterval(() => {
								if (this.cooling > 0) {
									this.cooling--
								} else {
									clearInterval(coolingInter)
								}
							}, 1000)
						} else {
							this.$refs.ruleForm.validateField('code', (errorMessage) => {
								if (errorMessage) {
									console.log('验证失败:', errorMessage);
								}
							});
						}
					});
			} else {
				this.$refs.ruleForm.validateField('loginName', (errorMessage) => {
					if (errorMessage) {
						console.log('手机号验证失败:', errorMessage);
					}
				});

			}

		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		alert(text, empty, key) {
			Modal.warning({
				title: '提示',
				content: text,
				onOk: () => {
					if (empty) {
						this.authInfo[key] = ''
					}
					console.log('确认按钮被点击');
				}
			});
		},
		handleMaxSize(file) {
			this.$Message.warning('上传的图片不能超过2M')
		},
		upLogo(res, key) {
			this.data[key] = this.domain.testUrl + this.domain.dataRealization + res.content.url
		},
		portalLoginClose() { //登录注册系列弹框
			this.visible = false;
			document.body.style.removeProperty('overflow');
		},
		loadResources() {
			this.resources.forEach(resource => {
				if (resource.type === 'css') {
					this.loadCSS(this.domain.testUrl + resource.href);
					// this.loadCSS('http://127.0.0.1:5500/' + resource.href);
				} else if (resource.type === 'js') {
					this.loadJS(this.domain.testUrl + resource.src);
					// this.loadJS('http://127.0.0.1:5500/' + resource.src);
				}
			});
		},
		loadResources_(data) {
			data.forEach(resource => {
				if (resource.type === 'css') {
					this.loadCSS(resource.href);
				} else if (resource.type === 'js') {
					this.loadJS(resource.src);
				}
			});
		},
		loadCSS(href) {
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = href;
			link.onload = () => {
				// console.log(`CSS loaded: ${href}`);
			};
			link.onerror = () => {
				console.error(`Failed to load CSS: ${href}`);
			};
			document.head.appendChild(link);
		},
		loadJS(src) {
			const script = document.createElement('script');
			script.src = src;
			// script.async = true;
			script.onload = () => {
				// console.log(`Script loaded: ${src}`);
				// 在这里可以调用该库提供的功能
			};
			script.onerror = () => {
				console.error(`Failed to load script: ${src}`);
			};
			document.body.appendChild(script);
		},
		updateAllComponents() {
			// 通过改变key的值来强制重新渲染所有组件
			this.$store.state.user.componentKey += 1;
			let key = this.$store.state.user.componentKey

			console.log('pppp=----------', key)
			this.updateComponentKey({
				key
			})
		},



	}
}